import React from "react";
import errorService from "app/utils/errorService";

interface ImageDownloadPageProps {
  imageUrl: string;
}

const ImageDownloadPage: React.FC<ImageDownloadPageProps> = ({ imageUrl }) => (
  <html lang="en" className="imageDownloadPage">
    <head>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Image - File</title>
      <style>
        {`
          html.imageDownloadPage {
            height: 100%;
            background-color: #000 !important;
          }

          html.imageDownloadPage body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background-color: #000 !important;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            min-height: 100vh;
            color: white;
          }

          html.imageDownloadPage img {
            max-width: 100%;
            max-height: 100vh;
            height: auto;
            border-radius: 4px;
            object-fit: contain;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
          }

          html.imageDownloadPage .image-container {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 100vh;
            padding: 20px;
            box-sizing: border-box;
            position: relative;
          }

          html.imageDownloadPage .error-message {
            color: #ff6b6b;
            font-size: 18px;
            text-align: center;
            padding: 20px;
            background-color: rgba(255, 107, 107, 0.1);
            border-radius: 8px;
            border: 1px solid rgba(255, 107, 107, 0.3);
          }

          html.imageDownloadPage .loading {
            color: #ffffff;
            font-size: 16px;
            text-align: center;
          }

          /* Support for different image formats */
          html.imageDownloadPage img[src*=".svg"] {
            background-color: rgba(255, 255, 255, 0.1);
            padding: 20px;
          }

          html.imageDownloadPage img[src*=".gif"] {
            /* Ensure GIFs display properly */
            image-rendering: auto;
          }

          html.imageDownloadPage img[src*=".webp"] {
            /* WebP support */
            image-rendering: auto;
          }

          /* Responsive design for different screen sizes */
          @media (max-width: 768px) {
            html.imageDownloadPage .image-container {
              padding: 10px;
            }

            html.imageDownloadPage img {
              max-height: 90vh;
            }
          }

          @media (max-width: 480px) {
            html.imageDownloadPage .image-container {
              padding: 5px;
            }

            html.imageDownloadPage img {
              max-height: 85vh;
            }
          }
        `}
      </style>
    </head>
    <body>
      <div className="image-container">
        <img
          src={imageUrl}
          alt="Media to be downloaded"
          onError={() => {
            errorService.error("Image could not be loaded. Please check the url or your connection.");
          }}
          onLoad={e => {
            const target = e.target as HTMLImageElement;
            target.style.opacity = "0";
            target.style.transition = "opacity 0.3s ease-in-out";
            setTimeout(() => {
              target.style.opacity = "1";
            }, 100);
          }}
        />
      </div>
    </body>
  </html>
);

export default ImageDownloadPage;
